<template>
  <div class="pricing-page">
    <h2>定价方案</h2>
    <p class="lead">
      内测期间 <strong>完全免费</strong>。以下为正式版参考档位（价格占位，尚未开放购买）。
    </p>

    <el-alert
      :title="freeQuotaNotice"
      type="warning"
      :closable="false"
      show-icon
      class="alert-block"
    />

    <el-alert
      title="支付功能尚未上线，敬请期待。内测用户正式收费前将提前通知。"
      type="info"
      :closable="false"
      show-icon
      class="alert-block"
    />

    <div v-loading="loading" class="plan-cards">
      <div
        v-for="plan in displayPlans"
        :key="plan.planCode"
        class="plan-card"
        :class="{ 'plan-card--free': plan.planCode === 'FREE' }"
      >
        <div class="plan-name">
          {{ planLabel(plan.planCode) }}
          <span v-if="plan.planCode === 'FREE'" class="temp-badge">测试期临时额度</span>
        </div>
        <div class="plan-price">{{ priceLabel(plan.planCode) }}</div>
        <ul class="plan-features">
          <li>单文件 {{ formatFileSizeMb(plan.maxFileMb) }}</li>
          <li>时长 {{ plan.maxDurationMin }} 分钟</li>
          <li>{{ plan.slicesPerDay }} 次任务/日</li>
          <li>{{ plan.slicesPerMonth }} 次任务/月</li>
          <li>{{ plan.priorityQueue ? '优先队列' : '标准队列' }}</li>
        </ul>
        <p v-if="plan.planCode === 'FREE'" class="free-restore-hint">
          正式收费后恢复：单文件 {{ formatFileSizeMb(formalFree.maxFileMb) }} /
          时长 {{ formalFree.maxDurationMin }} 分钟（日/月次数不变）
        </p>
        <el-button disabled size="small" class="buy-btn">即将开放</el-button>
      </div>
    </div>

    <p class="footnote">
      Pro 参考价 ¥19～49/月（待市场调研）。内测结束 `BETA_FREE` 将平滑升级为 `FREE`；
      测试期临时放宽的免费额度，在正式收费上线后恢复为 1GB / 45 分钟。
    </p>
  </div>
</template>

<script>
import { fetchQuotaPlans } from '../api/auth';
import { planLabel } from '../constants/planLabels';
import { FREE_QUOTA_BETA_NOTICE, FREE_QUOTA_FORMAL } from '../constants/freeQuotaNotice';
import { formatFileSizeMb } from '../utils/formatQuota';

const PRICE_HINT = {
  FREE: '免费',
  PRO: '¥29/月起（占位）',
  PRO_PLUS: '¥49/月起（占位）',
};

export default {
  name: 'PricingPage',
  data() {
    return {
      loading: false,
      plans: [],
      freeQuotaNotice: FREE_QUOTA_BETA_NOTICE,
      formalFree: FREE_QUOTA_FORMAL,
    };
  },
  computed: {
    displayPlans() {
      const order = ['FREE', 'PRO', 'PRO_PLUS'];
      return [...this.plans]
        .filter((p) => p.planCode !== 'TEAM')
        .sort((a, b) => order.indexOf(a.planCode) - order.indexOf(b.planCode));
    },
  },
  async mounted() {
    this.loading = true;
    try {
      this.plans = await fetchQuotaPlans();
    } catch (e) {
      this.$message.error(e.message || '加载失败');
    } finally {
      this.loading = false;
    }
  },
  methods: {
    planLabel,
    formatFileSizeMb,
    priceLabel(planCode) {
      return PRICE_HINT[planCode] || '待定';
    },
  },
};
</script>

<style scoped>
.pricing-page {
  background: rgba(15, 23, 42, 0.55);
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 10px;
  padding: 20px 22px;
}
h2 { margin: 0 0 10px; font-size: 20px; }
.lead { color: #94a3b8; line-height: 1.6; margin: 0 0 16px; }
.alert-block { margin-bottom: 12px; }
.plan-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 14px;
  margin-top: 8px;
}
.plan-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  border: 1px solid rgba(148, 163, 184, 0.25);
  border-radius: 8px;
  padding: 16px;
  background: rgba(30, 41, 59, 0.5);
}
.plan-card--free {
  border-color: rgba(251, 191, 36, 0.55);
  box-shadow: 0 0 0 1px rgba(251, 191, 36, 0.15);
}
.plan-name {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 6px;
}
.temp-badge {
  font-size: 11px;
  font-weight: 600;
  color: #78350f;
  background: #fbbf24;
  border-radius: 4px;
  padding: 2px 6px;
}
.plan-price { font-size: 22px; color: #5eead4; margin-bottom: 12px; }
.plan-features {
  flex: 1;
  margin: 0 0 10px;
  padding-left: 18px;
  color: #94a3b8;
  font-size: 13px;
  line-height: 1.7;
}
.free-restore-hint {
  margin: 0 0 12px;
  padding: 8px 10px;
  font-size: 12px;
  line-height: 1.5;
  color: #fef3c7;
  background: rgba(251, 191, 36, 0.12);
  border: 1px solid rgba(251, 191, 36, 0.35);
  border-radius: 6px;
}
.buy-btn { width: 100%; margin-top: auto; }
.footnote {
  margin-top: 20px;
  font-size: 12px;
  color: #64748b;
  line-height: 1.6;
}
</style>
